import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const ReminderSystem = () => {
    return (
        <WrapperLayout>
            <Main />
        </WrapperLayout>
    )
}
export default ReminderSystem